import siteImportDark from './site-import-dark.png';
import siteImportLight from './site-import-light.png';
import siteMultipleClientsDark from './site-multiple-clients-dark.raw.svg';
import siteMultipleClientsLight from './site-multiple-clients-light.raw.svg';

/**
 * Illustrations used in cards.
 */

export const siteMultipleClients = {
    light: siteMultipleClientsLight,
    dark: siteMultipleClientsDark,
};

export const siteImport = {
    light: siteImportLight,
    dark: siteImportDark,
};
